export default __webpack_public_path__ + "static/media/mision.f9f44248.png";